import { enumParser } from '#validation/common/parsers';
import { UserStatus } from '../constants';
export const userStatusParser = enumParser(UserStatus);
